import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RsFooterComponent } from '@rs-shared-lib/components/footer/rs-footer.component';
import { RsLoaderComponent } from '@rs-shared-lib/components/rs-loader/components/rs-loader.component';
import { RsTopBarMenuComponent } from '@rs-shared-lib/components/topbar/rs-top-bar-menu.component';
import { MenuItem } from '@rs-shared-lib/models';
import { ROUTES } from '@app/app.routes-constants';
import { Title } from '@angular/platform-browser';
import { BRAND_NAMES } from '@rs-shared-lib/constants/brand-names';
import { FeatureAccessRightsService } from '@app/shared/features/access-rights/services/feature-access-rights.service';
import { UserDetailsResponse } from '@api-client/mobipay';
import FeaturesEnum = UserDetailsResponse.FeaturesEnum;

/** todo: Change inbound and outbound everywhere in the app with new send/received */

@Component({
  imports: [RouterOutlet, TranslateModule, RsFooterComponent, RsLoaderComponent, RsTopBarMenuComponent],
  selector: 'mobipay-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  // DI
  private readonly titleService = inject(Title);
  private readonly featureAccessRights = inject(FeatureAccessRightsService);

  /**
   * The code the top bar identifies this app by — not a display name. The top bar owns its own
   * label and derives it from this code, so it must stay the code the top bar knows.
   */
  protected readonly topBarApplicationCode = 'REI';

  public readonly menuItems = computed<MenuItem[]>(() => ([
    {
      id: 'transactions',
      label: 'TRANSACTIONS',
      display: this.featureAccessRights.hasAnyOf([
        FeaturesEnum.TodoTransactions,
        FeaturesEnum.CanceledTransactions
      ]),
      url: this.featureAccessRights.has(FeaturesEnum.TodoTransactions) ?
        ROUTES.TRANSACTIONS.TODO :
        ROUTES.TRANSACTIONS.CANCELLED,
    },
    {
      id: 'invoices',
      label: 'INVOICES',
      display: this.featureAccessRights.hasAnyOf([
        FeaturesEnum.InboundInvoices,
        FeaturesEnum.OutboundInvoices
      ]),
      url: this.featureAccessRights.has(FeaturesEnum.OutboundInvoices) ?
        ROUTES.INVOICES.OUTBOUND :
        ROUTES.INVOICES.INBOUND
    },
  ]));

  public ngOnInit(): void {
    this.titleService.setTitle(BRAND_NAMES['REI']);
  }

  public onLogout(): void {
    localStorage.clear();
  }
}
